<div class="dtfuseAndPrivacy" *ngIf="isCanadaPortal">
    <!--Announcement Banner Code-->
    <div class="dtf-alertpage"></div>

    <section class='mbfs-repay-banner-inner'>
        <div class="mbfs-repay-banner-inner__box">
          <div class="mbfs-repay-banner-inner__box--text2">
            <h2 class="mbfs-repay-banner-inner__header-title">
              {{ 'PaymentOption.PO' | translate }}
            </h2>
            <p class="mbfs-repay-banner-inner__header-text2"> {{ 'PaymentOption.PO1' | translate }} 
            </p>
          </div>
        </div>
      </section>
      <div class="mbfs-repay-banner-inner__header-text2" style="padding-top: 21px; padding-bottom: 15px; padding-left: 81px;  padding-right: 81px;">
        <div class="row">
          <div class="col-sm-6">
          <h2> {{ 'PaymentOption.PO2' | translate }}</h2><br>
          <p> {{ 'PaymentOption.PO3' | translate }}</p><br>
          <p> {{ 'PaymentOption.PO16' | translate }}</p>
          </div>
    
          <div class="col-sm-6">
            <h2> {{ 'PaymentOption.PO7' | translate }}</h2><br>
            <p> {{ 'PaymentOption.PO8' | translate }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
          <h2> {{ 'PaymentOption.PO4' | translate }}</h2>
          <p> {{ 'PaymentOption.PO5' | translate }}</p>
          <p> {{ 'PaymentOption.PO6' | translate }}</p>
          </div>
    
          <div class="col-sm-6">
            <h2> {{ 'PaymentOption.PO9' | translate }}</h2>
          <p> {{ 'PaymentOption.PO10' | translate }}</p>
          <span> {{ 'PaymentOption.PO11' | translate }}</span><br>
          <span> {{ 'PaymentOption.PO12' | translate }}</span><br>
          <span> {{ 'PaymentOption.PO13' | translate }}</span><br>
          <span> {{ 'PaymentOption.PO14' | translate }}</span><br><br>
          <p> {{ 'PaymentOption.PO15' | translate }}</p>
          </div>
        </div>
    </div>
  